// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"acae05c8","828":"9db0e78c"}[chunkId] + ".chunk.js";
};